import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { IMG } from "@/lib/images";
import { ProductCard, RecipeCard, StarRating, Badge, SectionHeader } from "@/components/kit";
import { Award, Wine, Gift, Users } from "lucide-react";

const BADGE_ICON = { "Tequila Lover": Wine, "Bourbon Collector": Award, "Wedding Planner": Gift, "Beach Entertainer": Users, "Home Bartender": Wine };

export default function Profile() {
  const { user } = useAuth();
  const [products, setProducts] = useState([]);
  const [recipes, setRecipes] = useState([]);
  const [regs, setRegs] = useState([]);
  useEffect(() => {
    api.get("/products?sort=rating").then((r) => setProducts(r.data.slice(0, 3)));
    api.get("/recipes").then((r) => setRecipes(r.data.slice(0, 3)));
    api.get("/registries").then((r) => setRegs(r.data.slice(0, 2)));
  }, []);
  if (!user) return null;

  return (
    <div>
      <div className="relative h-48 overflow-hidden lg:h-60"><img src={IMG.heroBar} alt="" className="h-full w-full object-cover" /><div className="absolute inset-0 bg-gradient-to-t from-background to-transparent" /></div>
      <div className="mx-auto max-w-5xl px-6">
        <div className="-mt-12 flex flex-col items-start gap-4 sm:flex-row sm:items-end">
          <img src={user.avatar} alt="" className="h-24 w-24 rounded-full border-4 border-background object-cover" />
          <div className="flex-1 pb-1">
            <h1 className="font-display text-4xl">{user.name}</h1>
            <p className="text-sm text-muted-foreground">{user.bio}</p>
          </div>
        </div>

        <div className="mt-5 flex flex-wrap gap-2">
          {(user.badges || []).map((b) => { const Icon = BADGE_ICON[b] || Award; return <span key={b} className="inline-flex items-center gap-1.5 rounded-full bg-primary/10 px-3 py-1.5 text-sm font-medium text-primary"><Icon size={14} /> {b}</span>; })}
        </div>

        <div className="mt-6">
          <p className="mb-2 text-sm font-semibold">Favorite categories</p>
          <div className="flex flex-wrap gap-2">{(user.favorites || []).map((f) => <Badge key={f}>{f}</Badge>)}</div>
        </div>

        <div className="my-10 space-y-10">
          <section><SectionHeader overline="Top shelf picks" title="Recent ratings" /><div className="grid grid-cols-2 gap-5 lg:grid-cols-3">{products.map((p) => <ProductCard key={p.id} p={p} />)}</div></section>
          <section><SectionHeader overline="Saved" title="Saved recipes" /><div className="grid grid-cols-2 gap-5 lg:grid-cols-3">{recipes.map((r) => <RecipeCard key={r.id} r={r} />)}</div></section>
          <section>
            <SectionHeader overline="Hosting" title="Active registries" />
            <div className="grid gap-4 sm:grid-cols-2">
              {regs.map((r) => (
                <Link key={r.id} to={`/registry/${r.id}`} className="card-lift flex gap-4 rounded-xl border border-border bg-card p-4">
                  <img src={r.image} alt="" className="h-20 w-20 rounded-lg object-cover" />
                  <div className="min-w-0 flex-1"><span className="overline text-primary">{r.occasion}</span><p className="font-display text-xl hover-underline">{r.title}</p><div className="mt-2 h-1.5 rounded-full bg-muted"><div className="h-full rounded-full bg-primary" style={{ width: `${r.progress}%` }} /></div></div>
                </Link>
              ))}
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
